module.exports = __webpack_public_path__ + "img/none.0253c6af.svg";